import { useContext } from 'react';
import { CalendarStateContext } from 'react-aria-components';

export const useCalendarContext = () => {
  const state = useContext(CalendarStateContext);

  if (!state) throw new Error('CalendarStateContext is not provided');

  return state;
};
